/* eslint-disable graphql/template-strings */
import gql from 'graphql-tag';

export const onDemandAssignmentPresentationsFragments = gql`
  fragment GradeFragment on NaptimeOnDemandAssignmentPresentationsV1_grade {
    rawScore
    passingFraction
    maxScore
  }

  fragment ReviewPhaseFragment on NaptimeOnDemandAssignmentPresentationsV1_phases_reviewPhase {
    typeName
    definition {
      baseTaskId
      deadline

      # You need to comment this if you want to generate flow types from this query.
      # Then fix it manually.
      givenReviewTasks @type(name: "NaptimeOnDemandAssignmentPresentationsV1_Task") {
        reviewee
        revieweeProfile
        ...FormTaskFragment
      }
      receivedReviewCount
      requiredReviewsToGive
      requiredReviewsToReceive
      willBeStaffReviewed
      reviewsWillBeShownToLearner
      fulfilledGivenReviews
      fulfilledReceivedReviews
      canRequestAllocation
      isPendingAllocation
      givenReviewCount
    }
  }

  fragment FormTaskFragment on NaptimeOnDemandAssignmentPresentationsV1_Task {
    taskIdHash
    validationErrors {
      ...ValidataionErrorsFragment
    }
    updatedAt
    submittedAt
    executionId
    versionedExecutionId
    possibleActions
    lastSubmittedAt
    proctoring {
      ...ProctoringFragment
    }
    availabilityWindow {
      startsAt
      endsAt
    }
    # You need to comment this if you want to generate flow types from this query, then fix it
    # manually. It has troubles with Naptime vs GraphQL unions.
    form
  }

  fragment ValidataionErrorsFragment on NaptimeOnDemandAssignmentPresentationsV1_Task_validationErrors {
    id
    error {
      reason {
        ...ValidationErrorReasonFragment
      }
      debugMessage
    }
  }

  fragment ProctoringFragment on NaptimeOnDemandAssignmentPresentationsV1_Task_proctoring {
    completedAttempts
    remainingAttempts
    remainingSubmissionsInAttempt
    attemptDeadline
    nextAttemptDuration
    needsDraftSubmission
    serverTimestamp
    secondsLeftInLatestAttempt
    nextAttemptSubmissionLimit
  }

  fragment ValidationErrorReasonFragment on NaptimeOnDemandAssignmentPresentationsV1_Task_validationErrors_error_reason {
    ... on NaptimeOnDemandAssignmentPresentationsV1_Task_validationErrors_error_reason_invalidCml {
      typeName
      definition
    }
    ... on NaptimeOnDemandAssignmentPresentationsV1_Task_validationErrors_error_reason_tooLong {
      typeName
      definition
    }
    ... on NaptimeOnDemandAssignmentPresentationsV1_Task_validationErrors_error_reason_generic {
      typeName
      definition
    }
    ... on NaptimeOnDemandAssignmentPresentationsV1_Task_validationErrors_error_reason_invalidUrl {
      typeName
      definition
    }
    ... on NaptimeOnDemandAssignmentPresentationsV1_Task_validationErrors_error_reason_empty {
      typeName
      definition
    }
    ... on NaptimeOnDemandAssignmentPresentationsV1_Task_validationErrors_error_reason_missingReviewPart {
      typeName
      definition
    }
  }
`;

export default onDemandAssignmentPresentationsFragments;
